import { combineReducers } from 'redux';

const isClicked = (state = false, action) => {
  switch (action.type) {
    case 'SET_OFFER_CLICKED':
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  isClicked,
});
